/* =========================================================================
   LEARN HUB — UTM & CAMPAIGN CAPTURE  (for Meta / Facebook & Instagram ads)
   File: assets/learn-utm.js   ·   loaded by sections/learn-subnav.liquid

   Plain-English summary of what this does:
     1. When someone arrives from a Meta ad, it reads the ?utm_… tags that
        the ad put on the URL.
     2. It remembers them in the browser for 90 days. FIRST TOUCH WINS — the
        ad that first brought the person is the one that gets the credit.
     3. It stamps that campaign onto the two things you care about:
          a) the Academy waitlist signup  → tags on the customer in Shopify
                                             (Admin → Customers, filter by tag)
          b) the Shopify cart              → shows on the toolkit ORDER
                                             (Admin → Orders → Additional details)
     4. It keeps the campaign attached when a visitor clicks through to the
        Academy / toolkit CTAs, so the whole funnel stays attributed.
     5. If a Meta Pixel is present on the page, it fires a "Lead" event when
        the waitlist form is submitted. (Harmless if no pixel is installed.)

   There is NOTHING to configure here — no pixel ID, no campaign names.
   Those all live in the ad URLs you build in Meta Ads Manager. Pure browser
   JS, per the project rule that no JS lives inside .liquid files.
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'layerd_attribution';
  var CART_FLAG   = 'layerd_cart_tagged';
  var MAX_AGE_DAYS = 90;
  var UTM_KEYS   = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_KEYS = ['fbclid', 'gclid']; // ad click ids — useful when debugging

  /* ---- 1. Read the UTM tags off the current URL ------------------------ */
  function readFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var found = {}, has = false;
    UTM_KEYS.concat(CLICK_KEYS).forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v.slice(0, 200); has = true; }
    });
    return has ? found : null;
  }

  /* ---- 2. First-touch memory (first ad wins, kept 90 days) ------------- */
  function load() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - (data._ts || 0) > MAX_AGE_DAYS * 864e5) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  function save(data) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function getAttribution() {
    var stored = load();
    var fresh  = readFromUrl();

    if (fresh && !stored) {            // brand-new visitor from an ad
      fresh._ts = Date.now();
      fresh._landing = window.location.pathname;
      save(fresh);
      return fresh;
    }
    if (fresh && stored) {             // returning visitor, clicked another ad
      stored._last_campaign = fresh.utm_campaign || stored._last_campaign;
      save(stored);                    // keep first touch, note the latest
    }
    return stored;
  }

  /* ---- helpers --------------------------------------------------------- */
  function slug(s) {
    return String(s).toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40);
  }

  function utmQuery(attr) {
    return UTM_KEYS
      .filter(function (k) { return attr[k]; })
      .map(function (k) { return k + '=' + encodeURIComponent(attr[k]); })
      .join('&');
  }

  /* ---- 3a. Stamp the waitlist form (Shopify customer tags) ------------- */
  function tagWaitlistForm(attr) {
    var form = document.getElementById('learn-waitlist-form');
    if (!form) return;
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput) return;

    var extra = [];
    if (attr.utm_source)   extra.push('src-'  + slug(attr.utm_source));
    if (attr.utm_medium)   extra.push('med-'  + slug(attr.utm_medium));
    if (attr.utm_campaign) extra.push('camp-' + slug(attr.utm_campaign));
    if (attr.utm_content)  extra.push('ad-'   + slug(attr.utm_content));
    if (!extra.length) return;

    // append to whatever Liquid already put there (academy-waitlist,learn-<tool>)
    var current = tagsInput.value ? tagsInput.value.split(',') : [];
    extra.forEach(function (t) { if (current.indexOf(t) === -1) current.push(t); });
    tagsInput.value = current.join(',');
  }

  /* ---- 3b. Stamp the Shopify cart (rides along to the ORDER) ----------- */
  function tagCart(attr) {
    var attributes = {};
    UTM_KEYS.forEach(function (k) { if (attr[k]) attributes[k] = attr[k]; });
    if (attr._landing) attributes.landing_page = attr._landing;
    if (!Object.keys(attributes).length) return;

    // write once per browser session, not on every page view
    try { if (window.sessionStorage.getItem(CART_FLAG)) return; } catch (e) {}

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function () {
      try { window.sessionStorage.setItem(CART_FLAG, '1'); } catch (e) {}
    }).catch(function () {});
  }

  /* ---- 3c. Keep the campaign attached to the CTA click-throughs -------- */
  function decorateLinks(attr) {
    var q = utmQuery(attr);
    if (!q) return;
    var sel = '.learn-cta a.learn-btn, a.lh-locked__cta, a.lh-locked__alt';
    document.querySelectorAll(sel).forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('utm_') !== -1) return;          // already tagged
      if (/^(#|mailto:|tel:)/.test(href)) return;                // skip anchors
      a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + q);
    });
  }

  /* ---- 4. Fire a Meta "Lead" event on waitlist submit ----------------- */
  function wireLeadEvent(attr) {
    var form = document.getElementById('learn-waitlist-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Academy waitlist',
          campaign: (attr && attr.utm_campaign) || '(none)',
          source:   (attr && attr.utm_source)   || '(none)'
        });
      }
    });
  }

  /* ---- run ------------------------------------------------------------- */
  function init() {
    var attr = getAttribution();
    if (attr) {
      tagWaitlistForm(attr);
      tagCart(attr);
      decorateLinks(attr);
    }
    wireLeadEvent(attr); // fire Lead even for organic signups
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
